import { AxiosResponse } from "axios";

import { API } from "../index";
import { BenefitRulePayload } from "../types/benefit";

export const benefitService = {
  listRules: async (): Promise<AxiosResponse> => {
    return await API.get(`/benefit/rules/`);
  },

  getRule: async (id: number): Promise<AxiosResponse> => {
    return await API.get(`/benefit/rules/${id}/`);
  },

  createRule: async (payload: BenefitRulePayload): Promise<AxiosResponse> => {
    return await API.post(`/benefit/rules/`, payload);
  },

  updateRule: async (id: number, payload: BenefitRulePayload): Promise<AxiosResponse> => {
    return await API.put(`/benefit/rules/${id}/`, payload);
  },

  deleteRule: async (id: number): Promise<AxiosResponse> => {
    return await API.delete(`/benefit/rules/${id}/`);
  },
};
